import { render } from "./places.vue?vue&type=template&id=848582e6"
import script from "./places.vue?vue&type=script&lang=js"
export * from "./places.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__